export const QUICK_QUOTE = 'quickQuote';
